import { bound } from "@frui.ts/helpers";
import { Router } from "@frui.ts/screens";
import { computed } from "mobx";
import PaymentsPairingRepository from "repositories/paymentsPairingRepository";
import EnumService from "services/enumService";
import EventBus, { paymentPaired } from "services/eventBus";
import LocalizationService from "services/localizationService";
import OptionsService from "services/optionsService";
import SecurityService from "services/securityService";
import ChargeOrderStatus from "entities/chargeOrderStatus";
import type CountrySelectViewModel from "../../../countrySelectViewModel";
import ChargeOrderSearchListViewModel from "../chargeOrderSearchListViewModel";
import PairingByOrderDetailViewModel from "./pairingByOrderDetailViewModel";
import PriceListService from "services/priceListService";
import { translateChargeTypeByPriceListItem } from "utils/chargeType";

const navigationName = "orders";

@Router.registerRoute({ name: Router.Self, route: navigationName, children: [PairingByOrderDetailViewModel] })
export default class PairingByOrderListViewModel extends ChargeOrderSearchListViewModel {
  constructor(
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected securityService: SecurityService,
    protected repository: PaymentsPairingRepository,
    protected detailViewModelFactory: ReturnType<typeof PairingByOrderDetailViewModel.Factory>,
    protected countrySelectViewModelFactory: ReturnType<typeof CountrySelectViewModel.Factory>,
    protected enumService: EnumService,
    protected priceListService: PriceListService,
    protected optionsService: OptionsService
  ) {
    super(countrySelectViewModelFactory);
    this.navigationName = navigationName;
  }

  onInitialize() {
    this.unsubscriptions.push(this.eventBus.subscribe(paymentPaired, this.onPaymentPaired));
    return super.onInitialize();
  }

  @computed
  get name() {
    if (!this.filterIsNotEmpty) {
      return this.translate("orders");
    } else {
      return this.translate("ordersCount").replace("%count%", this.currentPaging?.totalItems.toString() || "0");
    }
  }

  translateChargeType(priceListItemId?: string) {
    return translateChargeTypeByPriceListItem(this.priceListService, this.enumService, priceListItemId);
  }

  @bound
  onPaymentPaired(event: ReturnType<typeof paymentPaired>) {
    const pairedOrder = event.payload.order;

    const item = this.items.find(item => item.id === pairedOrder.id);
    if (item) {
      item.status = ChargeOrderStatus.Paid;
    }

    if (this.activeChild) {
      this.closeChild(this.activeChild);
    }
  }
}
